import api from '../axiosConfig';
const API_URL = '/api/csv-import-logs';

// Get all CSV import logs
export const fetchAllCsvImportLogs = () => api.get(API_URL);

// Get active CSV import logs only
export const fetchActiveCsvImportLogs = () => api.get(`${API_URL}/active`);

// Get CSV import log by ID
export const fetchCsvImportLogById = (id) => api.get(`${API_URL}/${id}`);

// Get CSV import log by reference number
export const fetchCsvImportLogByReference = (referenceNumber) => 
  api.get(`${API_URL}/reference/${referenceNumber}`);

// Create new CSV import log
export const createCsvImportLog = (logData) => api.post(API_URL, logData);

// Update CSV import log
export const updateCsvImportLog = (id, logData) => api.put(`${API_URL}/${id}`, logData);

// Update confirmation status
export const updateCsvImportLogConfirmation = (id, isConfirm) => {
  console.log('API call - updateCsvImportLogConfirmation:', { id, isConfirm, url: `${API_URL}/${id}/confirm` });
  return api.patch(`${API_URL}/${id}/confirm`, { is_confirm: isConfirm });
};

// Soft delete CSV import log
export const softDeleteCsvImportLog = (id) => api.delete(`${API_URL}/${id}/soft`);

// Hard delete CSV import log
export const hardDeleteCsvImportLog = (id) => api.delete(`${API_URL}/${id}`);

// Get logs by date range
export const fetchCsvImportLogsByDateRange = (startDate, endDate) => 
  api.get(`${API_URL}/date-range?startDate=${startDate}&endDate=${endDate}`);

// Get statistics
export const fetchCsvImportLogsStats = () => api.get(`${API_URL}/stats`);

// Get logs with available records
export const fetchCsvImportLogsWithRecords = () => api.get(API_URL); 